/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, error: NonNullable<unknown> }} Explorer_Info_Delete_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to delete \"{name}\": {error}" |
*
* @param {Explorer_Info_Delete_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_delete_failed_toast = /** @type {((inputs: Explorer_Info_Delete_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Delete_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de suppression de "${i?.name}" : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Löschen von "${i?.name}": ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile eliminare "${i?.name}": ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось удалить "${i?.name}": ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo eliminar "${i?.name}": ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`删除“${i?.name}”失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`「${i?.name}」の削除に失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`"${i?.name}" को हटाने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao excluir "${i?.name}": ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to delete "${i?.name}": ${i?.error}`)
});